/** @format */

import { Col, Container, Row } from "react-bootstrap";
import JobPostingForm from "./job-posting-form";
import background from "src/assets/images/9926.jpg";

const JobListing = () => {
  return (
    <>
      <div
        id="content-page"
        className="content-inner"
        style={{
          backgroundImage: `url(${background})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <Container>
          <Row className="gx-4">
            <Col md={8} className="text-center m-auto">
              <h1
                style={{ fontSize: "4rem", color: "black", fontWeight: "bold" }}
              >
                Coming Soon
              </h1>
              <p style={{ fontSize: "1.5rem", color: "black" }}>Stay tuned!</p>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default JobListing;
